import { render, staticRenderFns } from "./renwu_mingxi.vue?vue&type=template&id=b8be46be&scoped=true"
import script from "./renwu_mingxi.vue?vue&type=script&lang=js"
export * from "./renwu_mingxi.vue?vue&type=script&lang=js"
import style0 from "./renwu_mingxi.vue?vue&type=style&index=0&id=b8be46be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be46be",
  null
  
)

export default component.exports